import { Suspense, LazyExoticComponent } from 'react';

// material-ui
import { LinearProgressProps } from '@mui/material/LinearProgress';

// project imports
import Loader from './Loader';
import Head from './head';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

interface LoaderProps extends LinearProgressProps {}

const Loadable = (Component: LazyExoticComponent<() => JSX.Element>) => {
    const suspenseComponent = (props: LoaderProps) => {
        return (
            <Suspense fallback={<Loader />}>
                <Head />
                <Component {...props} />
            </Suspense>
        );
    };

    return suspenseComponent;
};

export default Loadable;
